import { Box, Typography } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import { SystemStyleObject } from "@styled-system/css";
import React from "react";

import TopicLink from "./TopicLink";
import { DEFAULT_TOPICS, TopicInfo, currentConditionalTopics } from "./Topics";

export default function TopicBanner({
  topics = DEFAULT_TOPICS,
  titleText,
  titleElement,
  outerContainerSx,
  innerContainerSx,
  topicSx = {},
  isCrossSell = false,
}: {
  topics?: TopicInfo[];
  titleText?: string;
  titleElement?: JSX.Element;
  outerContainerSx?: SystemStyleObject;
  innerContainerSx?: SystemStyleObject;
  topicSx?: SystemStyleObject;
  isCrossSell?: boolean;
}) {
  const topicList = React.useMemo(
    () => currentConditionalTopics().concat(topics),
    [topics]
  );

  const { t } = useTranslation("ui-components-website\\Topics\\TopicBanner");
  const title = titleElement || (
    <Typography
      sx={{
        paddingBottom: "1em",
      }}
      variant={isCrossSell ? "h3" : "h5"}
    >
      {titleText ?? t`More to explore`}
    </Typography>
  );

  return (
    <Box
      flex
      sx={{
        paddingTop: "3em",
        paddingBottom: "3em",
        alignItems: "center",
        flexDirection: "column",
        ...outerContainerSx,
      }}
    >
      {title}
      <Box
        flex
        sx={{
          flexWrap: "wrap",
          justifyContent: "center",
          columnGap: "0.5em",
          rowGap: "1em",
          width: "100%",
          ...innerContainerSx,
        }}
      >
        {topicList.map(topic => (
          <TopicLink topic={topic} key={topic.title} topicSx={topicSx} />
        ))}
      </Box>
    </Box>
  );
}
